import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import * as QRCode from "qrcode";
import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';


type Props = {
    setHiddenSaveBackupCardStatus:any,
    setQRTagStatus:any,
    // languageExchange:any,
}
export const SaveBackupCardButton: React.FC<Props> = (props) => {
 const [t, i18n] = useTranslation();
 async function onClickFunc() {
    //一時的に表示
    props.setHiddenSaveBackupCardStatus(`block`);
    //QRコード生成
    QRCode.toDataURL(`https://www.sushitop.io/index.html?pkey=${localStorage.getItem('privateKey')}`,function (error,url) {
      props.setQRTagStatus(<img src={url} style={imgStyle}></img>);
    });
    await new Promise(resolve => setTimeout(resolve, 500));
    //バックアップカードの保存
    await html2canvas(document.querySelector("#backupcard")).then( (canvas) => {
      canvas.toBlob((blob)=>{
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.download = 'nftbackupcard.jpg';
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
      });
    });
    await props.setHiddenSaveBackupCardStatus(`none`);
  }


  const imgStyle: React.CSSProperties = {
    display: 'block',
    width:256,
    height:256,
  };
  const SaveBackupCardButtonDiv = styled.div`
    justify-content: center;
    display: flex;
    margin-top: 10px;
  `;
  const SaveBackupCardButtonComponent = styled.p`
    color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4px;
    gap: 10px;
    width: 80%;
    height: 37px;
    background: #FFB16A;
    border: 1px solid #be732f;
    border-radius: 40px;
    flex: none;
    order: 3;
    align-self: stretch;
    flex-grow: 0;
    margin-top: 15px;
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  `;

  return (
    <SaveBackupCardButtonDiv id="savebackupcarddiv">
        <SaveBackupCardButtonComponent id="savebackupcard"onClick={onClickFunc}>{t('バックアップカードを保存する')}</SaveBackupCardButtonComponent>
    </SaveBackupCardButtonDiv>
  );
};